import {
  applicationsTabs,
  benefitAccordion,
  benefitTabs,
  catalog,
  counter,
  headInfoWindow,
  newsSliderMobile,
  projectSlider,
} from './components/home';
import {
  burgerInit,
  cookiesInit,
  inputMask,
  navigation,
  // popupCallback,
  popupInit,
  scrollTop,
  formCallback,
  initVideo,
  accordionInit
} from './components';
import { CatalogFilter, catalogNavigation, productFilter } from './components/catalog';
import {
  ExampleFilter,
  examplePopupSlider,
  exampleSlider,
  newsItemSlider,
  NewsList,
  newsLoad,
  productSlider,
  projectsFilter,
  secondInfoBlockSlider,
  systemAccordion,
  systemComponentsTabs,
  secondSlider,
  secondProductSlider,
  secondProjectsSlider
} from './components/second';

$(document).ready(init);

function init() {
  /*
   * Global
   * */

  inputMask();
  scrollTop();
  navigation();
  if (!document.querySelector('.policy-page')) {
    cookiesInit();
  }
  popupInit();
  // popupCallback();
  burgerInit();
  // formCallback();
  initVideo();
  accordionInit();

  /*
   * Home
   * */

  headInfoWindow();
  benefitTabs();
  benefitAccordion();
  catalog();
  applicationsTabs();
  projectSlider();
  counter();
  newsSliderMobile();

  /*
   * Catalog
   * */

  catalogNavigation();
  // const catalogFilter = new CatalogFilter();
  // catalogFilter.init();
  productFilter();

  /*
   * Second
   * */

  exampleSlider();
  systemComponentsTabs();
  newsItemSlider();
  productSlider();
  examplePopupSlider();
  systemAccordion();

  secondInfoBlockSlider();
  secondSlider();
  secondProductSlider();
  secondProjectsSlider();

  // const newsList = new NewsList();
  // newsList.init();
  newsLoad();

  // const examplesFilter = new ExampleFilter();
  // examplesFilter.init();
  projectsFilter();
}
